import { Helmet } from 'react-helmet-async';

const siteUrl = process.env.REACT_APP_SITE_URL || 'https://latchiya.com';

const SEOHead = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  structuredData,
}) => {
  const defaultTitle =
    'Latchiya Software Systems | Enterprise messaging, education and identity';
  const defaultDescription =
    'Founded in 2006 in Bangalore, Latchiya delivers m-REACH, eClassroomz, Documint, IDGate Check-In, Scan4Loyalty and mobile enterprise solutions for campaigns, collaboration, trusted credentials, verified visitor entry and wallet-based customer loyalty.';
  const defaultKeywords =
    'Latchiya, m-REACH, eClassroomz, Documint, IDGate, Scan4Loyalty, Aadhaar verification, visitor check-in, loyalty program, Apple Wallet, Google Wallet, SMS platform, school software, verifiable credentials, Bangalore, enterprise messaging';
  const defaultImage = `${siteUrl}/assets/images/latchiya_std.png`;

  const seoTitle = title ? `${title} | Latchiya` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image || defaultImage;
  const seoUrl = url || siteUrl;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <link rel="canonical" href={seoUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content="Latchiya" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
